module.exports = __webpack_public_path__ + "img/primo-logo.30e017a0.png";